<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>
        
        <v-alert  :value="true"  v-if="error != null" type="error" >{{ error.message }}</v-alert>

        <v-layout justify-center column>

          <v-form ref="form" v-model="valid" @submit="updateUser">
            
            <v-layout row>
              <v-flex xs12>
                <p class="notice">Thank you for your interest in Stoke City Football Club.</p>
                <p class="notice">Moving forward, we will be delighted to provide you with the latest news, ticketing &amp; retail updates, fixture information, special offers and behind the scenes content from Stoke City Football Club.</p>
                <p class="notice">If you do not wish to hear from us regarding the above, you can unsubscribe below.</p>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-switch
                  :label="`Email`"
                  v-model="clubEmail"
                  color="#5bb57c"
                ></v-switch>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-switch
                  :label="`Phone`"
                  v-model="clubPhone"
                  color="#5bb57c"
                ></v-switch>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-switch
                  :label="`SMS`"
                  v-model="clubSMS"
                  color="#5bb57c"
                ></v-switch>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 py-0>
                <v-switch
                  :label="`Direct Mail`"
                  v-model="clubDirect"
                  color="#5bb57c"
                ></v-switch>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pt-0 pb-1>
                <v-switch
                  id="termsSwitch"
                  :label="`I have read and understood the Club's privacy policy`"
                  v-model="termsAgree"
                  :rules="termsAgreeRules"
                  color="#D7172F"
                ></v-switch>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pt-0 pb-3>
                <p><a class="privacy-policy" href="https://www.stokecityfc.com/privacypolicy" target="_blank">https://www.stokecityfc.com/privacypolicy</a></p>
              </v-flex>
            </v-layout>
            <v-layout row align-center mx-1 py-0>
              <v-spacer />
              <button type="submit" class="button" :disabled="!valid">Complete Registration</button>
            </v-layout>
          </v-form>
        </v-layout>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Registration',
  data () {
    
    return {
      valid: true,
      firstNameRules: [
        v => !!v || 'First name is required'
      ],
      lastNameRules: [
        v => !!v || 'Last name is required'
      ],
      passRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Password must be at least 8 characters',
        v => /.*[a-z].*/.test(v) || 'Password must contain at least one lower case letter',
        v => /.*[A-Z].*/.test(v) || 'Password must contain at least one upper case letter',
        v => /\d/.test(v) || 'Password must contain at least one number',
        v => /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(v) || 'Password must contain at least one special character (e.g. ^ $ * . ! @ # % &)',
        v => (this.passConfirm.length >=8 && v == this.passConfirm) || 'Password confirmation must match password'
      ],
      passConfirmRules: [
        v => (v == this.pass) || 'Password confirmation must match password'
      ],
      usernameRules: [
        v => !!v || 'Email address is required',
        v => /.+@.+/.test(v) || 'Email must be valid'
      ],
      termsAgreeRules: [
        v => !!v || 'You must agree to continue'
      ],
      firstName: '',
      lastName: '',
      username: '',
      pass: '',
      clubEmail: true,
      clubDirect: true,
      clubSMS: true,
      clubPhone: true,
      termsAgree: false,
      passConfirm: '',
      error: null,
      loading: false
    }
  },
  watch: {
    pass: function (val, oldVal) {
      this.$refs.form.validate()
    },
    passConfirm: function (val, oldVal) {
      this.$refs.form.validate()
    }
  },
  methods: {
    updateUser (e) {
        e.preventDefault()
        this.ready = false
        
        var clubEmail = this.clubEmail.toString();
        var clubSMS = this.clubSMS.toString();
        var clubDirect = this.clubDirect.toString();
        var clubPhone = this.clubPhone.toString();
        var termsAgree = this.termsAgree.toString();
        
        var attributesList = {
            "custom:club_email": clubEmail, 
            "custom:club_phone": clubPhone, 
            "custom:club_sms": clubSMS, 
            "custom:club_direct": clubDirect, 
            "custom:privacy_accepted": termsAgree
        }
       
        this.$updateAttributes(attributesList).subscribe((response) => {
            console.log("update successful")
            if (localStorage.completeRegistrationRedirect){
              var redirect = localStorage.completeRegistrationRedirect
              console.log('redirecting to ' + localStorage.completeRegistrationRedirect)
              localStorage.removeItem('completeRegistrationRedirect')
              window.location = redirect
            } else {
              this.$router.push("/confirm");
            }   
        }, 
        (err)=> {
            //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
            console.log(err.message)
            this.success = null
            this.error = err
            this.ready = true
        });    
    }
  }
}
</script>

<style>
  .password-notice {
    margin: 0 0 20px;
    padding: 0 0 40px;
    color: #878787;
    font-size: 15px;
    line-height: 22px;
    border-bottom: 1px solid #eee;
  }

  
  .v-input--switch__track.theme--light.error--text {
    color: rgba(0,0,0,0.38) !important;
  }
  .v-input--selection-controls__ripple.error--text{
    color: #fff !important;
  }
  .v-input--switch__thumb.theme--light.error--text{
    color:#fafafa !important;
  }
</style>